import flattenDeep from 'lodash/flattenDeep'

export default function (...args) {
  const classNames = flattenDeep(args)

  return classNames.filter(i => !!i).join(' ')
}
